var React = require('react');

function ThumbsUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3 9.75h4.5v9.75H3a.75.75 0 0 1-.75-.75V10.5A.75.75 0 0 1 3 9.75v0ZM7.5 9.75l3.75-7.5a3 3 0 0 1 3 3V7.5h5.8a1.5 1.5 0 0 1 1.49 1.686l-1.126 9a1.5 1.5 0 0 1-1.488 1.314H7.5","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ThumbsUp.defaultProps = {"viewBox":"0 0 24 24","fill":"none","strokeWidth":"2.002"};

module.exports = ThumbsUp;

ThumbsUp.default = ThumbsUp;
